import {constantRouterMap} from '@/router'
import {getAuthMenuTree} from '@/api/customerRoleMenu'
import compMap from '@/router/compMap'

/**
 * 根据 菜单树生成路由
 * @param basePath 上一层的path
 * @param menuTrees
 * @returns {*}
 */
function generatorRoutes(basePath, menuTrees) {
  if (typeof menuTrees !== 'undefined') {
    return menuTrees.map(route => {
      route['path'] = route.url
      route['component'] = compMap[route.code]
      if (typeof route.children !== undefined && route.children !== null && route.children.length > 0) {
        route['redirect'] = basePath + route.path + '/' + route.children[0].url
        generatorRoutes(basePath + route.path + '/', route.children)
      } else { // 只有一级菜单的处理
        if (compMap[route.code].children) {

          if (route.code === 'alarmRecord')
            permission.state.showWarning = true
          route['path'] = route.url
          route['component'] = compMap[route.code].root
          route['children'] = compMap[route.code].children
          route['redirect'] = basePath + route.path + '/' + route.children[0].path
        }
      }
    })
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    showWarning: false,
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    SET_SHOWWARNING: (state, showWarning) => {
      state.showWarning = showWarning
    }
  },
  actions: {
    GenerateRoutes({commit}) {
      return new Promise((resolve, reject) => {
        getAuthMenuTree([2, 5]).then(res => {
          if (res.code === 200) {
            const menuTree = res.infoJson
            if (typeof menuTree !== 'undefined' && menuTree !== null) {
              let addRoutes = []
              menuTree.forEach(root => {
                // 预付费菜单
                if (root.group === 5) {
                  generatorRoutes('', root.children)
                  addRoutes = addRoutes.concat(root.children)
                }

                // 工程管理菜单
                if (root.group === 2) {
                  /* const pmsRoot = {
                    path: '/pmsRoot',
                    component: compMap['pmsRoot'],
                    name: root.name,
                    redirect: '/pmsRoot/' + root.url,
                    children: [
                      root
                    ]
                  }*/
                  generatorRoutes('', [root])
                  addRoutes.push(root)
                }
              })
              commit('SET_ROUTERS', addRoutes)
            }
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default permission
